module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby-source-wordpress-experimental/gatsby-browser.js'),
      options: {"plugins":[],"url":"https://starter.gatsby-wp.com/graphql","verbose":true,"excludeFieldNames":["blocksJSON","saveContent"]},
    },{
      plugin: require('../../../packages/gatsby-theme-blog-data/gatsby-browser.js'),
      options: {"plugins":[],"addColorModes":true,"skipTitle":"all","layoutWidth":{"page":"lg","post":"lg","archive":"lg"},"mailchimpEndpoint":false,"siteUrl":"https://example.com/","sidebarWidgets":["Categories","RecentPosts","Tags","SocialFollow","Newsletter"],"slideMenuWidgets":["Categories","RecentPosts","SocialFollow","Newsletter"],"archiveSidebar":"right","seoWithYoast":true,"fonts":["IBM Plex Mono","Roboto Slab"],"customFonts":["IBM Plex Mono","Roboto Slab"]},
    },{
      plugin: require('../../../packages/gatsby-plugin-wp-seo/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://example.com/"},
    },{
      plugin: require('../../../node_modules/@chakra-ui/gatsby-plugin/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../packages/gatsby-plugin-wordpress-lightbox/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../packages/gatsby-theme-wp-starter/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://example.com/","skipTitle":"all","layoutWidth":{"page":"lg","post":"lg","archive":"lg"},"sidebarWidgets":["Categories","RecentPosts","Tags","SocialFollow","Newsletter"],"slideMenuWidgets":["Categories","RecentPosts","SocialFollow","Newsletter"],"archiveSidebar":"right","seoWithYoast":true,"fonts":["IBM Plex Mono","Roboto Slab"],"customFonts":["IBM Plex Mono","Roboto Slab"]},
    }]
